import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import Select from "react-select";
import { useFormik } from 'formik';
// import { getJobOrderEmployeeList, getUnusedQuotationList } from '../../../../Redux/action/Joborder/JoborderAction';
import { toast } from 'react-toastify';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { adminMainUrl } from '../../../../../Config';
// import ConsoleShipmentHAWBAdd from './ConsoleShipmentHAWBAdd';
import { customStyles } from '../../../../../HelperFunctions';
import {
    getFFAirImpAirport,
    getFFAirImpCurrency,
    getFFAirImpFinalQuotation,
    getFFAirImpJobOrder,
    getFFAirImporDirectMAWBDetail,
    getFFAirImpOrganisation,
    //  getFFAirImportHAWBDetail 
} from '../../../../../Redux/action/FreightForwarding/Console/FFAirImpAction';
import Beatloader from '../../../../../Common/Loaders/Beatloader';
import ConsoleShipmentHAWBEdit from './ConsoleShipmentHAWBEdit';
// import DirectShipmentMAWBAdd from './DirectShipmentMAWBAdd';
// import DirectShipmentMAWBEdit from './DirectShipmentMAWBEdit';
import DirectShipmentMAWBEditAI from './DirectShipmentMAWBEditAI';
import { getMasterIATAAgent } from '../../../../../Redux/action/MasterAction';

const EditFFDirectMAWBAI = ({ accessedModules, accessedPermission, impexp }) => {
    const { b64id } = useParams();
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [disableQuotationField, setDisableQuotationField] = useState(false);
    const [showLoader, setShowLoader] = useState(true);

    const queryParams = new URLSearchParams(location.search);
    const qId = queryParams.get('q_id'); // Retrieve the value of q_id

    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');

    useEffect(() => {
        if (token && user_id) {
            dispatch(getFFAirImpJobOrder(token, user_id));
            dispatch(getFFAirImpFinalQuotation(token, user_id));
            dispatch(getFFAirImpCurrency(token, user_id));
            dispatch(getFFAirImpAirport(token, user_id));
            dispatch(getFFAirImpOrganisation(token, user_id));
            dispatch(getMasterIATAAgent(token, user_id));

            if (b64id) {
                let direct_mawb_id = atob(b64id);
                if (direct_mawb_id) {
                    dispatch(getFFAirImporDirectMAWBDetail(token, user_id, direct_mawb_id))
                }
            } else {
                toast.error("Please enter correct URL.");
                navigate(-1);
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }

    }, [token, user_id, b64id]);


    const {
        loadingFFAirImpJobOrderList,
        // FFAirImpJobOrderListError,
        FFAirImpJobOrderList,

        loadingFFAirImpFinalQuotationList,
        // FFAirImpFinalQuotationListError,
        FFAirImpFinalQuotationList,

        loadingFFAirImpCurrencyList,
        // FFAirImpCurrencyListError,
        FFAirImpCurrencyList,

        loadingFFAirImpAirportList,
        // FFAirImpAirportListError,
        FFAirImpAirportList,

        //organisation list
        loadingFFAirImpOrganisationList,
        FFAirImpOrganisationList,
        // FFAirImpOrganisationListError,


        loadingFFAirImpDirectMAWBDetail,
        FFAirImpDirectMAWBDetail,
        // FFAirImpDirectMAWBDetailError

    } = useSelector(state => state?.FFAirImpReducer);

    const {
        loadingMasterIATAAgent,
        MasterIATAAgent,
        MasterIATAAgentError

    } = useSelector(state => state?.MasterReducer);


    const [iataAgentOptions, setIATAAgentOptions] = useState([]);
    useEffect(() => {
        if (MasterIATAAgent) {
            let arr = [];
            MasterIATAAgent.map(v => { arr.push({ value: v.id, label: `${v.name} - ${v.iata_code}` }) });
            setIATAAgentOptions(arr);
        } else {
            setIATAAgentOptions([]);
        }
    }, [MasterIATAAgent])


    const [jobOrderOptions, setJobOrderOptions] = useState([]);
    useEffect(() => {
        if (FFAirImpJobOrderList) {
            let arr = [];
            FFAirImpJobOrderList.map(val => arr.push({ value: val.id, label: val.job_order_unique_no, quotation_id: Number(val.quotation_id) }));
            setJobOrderOptions(arr);
        }
    }, [loadingFFAirImpJobOrderList, FFAirImpJobOrderList]);

    const [organisationOptions, setOrganisationOptions] = useState([]);
    useEffect(() => {
        if (FFAirImpOrganisationList) {
            let arr = [];
            FFAirImpOrganisationList.map(val => arr.push({ value: val.id, label: `${val.name} (${val.customerType})`, entity: val.entity_type ? JSON.parse(val.entity_type) : [] }));
            setOrganisationOptions(arr);
        }
    }, [FFAirImpOrganisationList]);

    const [finalQuotationOptions, setFinalQuotationOptions] = useState([]);
    useEffect(() => {
        if (FFAirImpFinalQuotationList) {
            let arr = [];
            FFAirImpFinalQuotationList.map(val => arr.push({ value: val.id, label: val.ship_quotation_no }));
            setFinalQuotationOptions(arr);
        }
    }, [loadingFFAirImpFinalQuotationList, FFAirImpFinalQuotationList]);

    const [currencyOptions, setCurrencyOptions] = useState([]);
    useEffect(() => {
        if (FFAirImpCurrencyList) {
            let arr = [];
            FFAirImpCurrencyList.map(val => arr.push({ value: val.id, label: `${val.currency} (${val.currency_symbol})` }));
            setCurrencyOptions(arr);
        }
    }, [loadingFFAirImpCurrencyList, FFAirImpCurrencyList]);

    const [airportOptions, setAirportOptions] = useState([]);
    useEffect(() => {
        if (FFAirImpAirportList) {
            let arr = [];
            FFAirImpAirportList.map(val => arr.push({ value: val.id, label: `${val.name} (${val.code}) - ${val.country_name}` }));
            setAirportOptions(arr);
        }
    }, [loadingFFAirImpAirportList, FFAirImpAirportList]);



    const initialValues = {
        trans_mode: "Direct Shipment",
        trans_type: "",
        job_order_id: "",
        quotation_id: "",
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            // console.log(values);
            setDisableSubmit(true);
            if (!values.customer_branch_id) {
                values.customer_branch_id = null;
            }
            try {
                let config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id')
                    }
                }
                let id = atob(b64id);
                if (id) {
                    values.id = id
                } else {
                    toast.error("Id not defined.");
                    return;
                }
                axios.post(`${adminMainUrl}/api/jobOrder/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            navigate(`/flexichain/job-order/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });



    useEffect(() => {
        if (loadingFFAirImpDirectMAWBDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        if (FFAirImpDirectMAWBDetail) {
            // console.log(FFAirImpDirectMAWBDetail);
            formik.setFieldValue("job_order_id", FFAirImpDirectMAWBDetail.job_order_id);
            formik.setFieldValue("quotation_id", FFAirImpDirectMAWBDetail.quotation_id);
        }
    }, [loadingFFAirImpDirectMAWBDetail, FFAirImpDirectMAWBDetail])



    let [showFormOf, setShowFormOf] = useState(null);
    useEffect(() => {
        if (formik.values.trans_mode == "Direct Shipment") {
            setShowFormOf("direct_shipment")
        } else if (formik.values.trans_mode == "Console Shipment") {
            setShowFormOf("console_shipment")
        } else {
            setShowFormOf(null)
        }
    }, [formik.values.trans_mode])

    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <div className="page-wrapper">
                        <div className="content">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <h6>Edit Freight Forwarding Details</h6>
                                    </div>
                                    {/* Filter */}
                                    {/* <form onSubmit={formik.handleSubmit}> */}
                                    <div className="row">
                                        <div className="col-md-12 mt-2">
                                            <div className='ms-2'>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                    Shipment Mode
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                    <div className="row">
                                                        {/* <div className="col-md-6">
                                                            <label>
                                                                <input
                                                                    type="radio"
                                                                    className="me-1"
                                                                    name="trans_mode"
                                                                    value="Direct Shipment"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    checked={formik.values.trans_mode === "Direct Shipment"}
                                                                />
                                                                Direct Shipment
                                                            </label>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <label>
                                                                <input
                                                                    type="radio"
                                                                    className="me-1"
                                                                    name="trans_mode"
                                                                    value="Console Shipment"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    checked={formik.values.trans_mode === "Console Shipment"}
                                                                />
                                                                Console Shipment
                                                            </label>
                                                        </div> */}
                                                        <h4>Direct Shipment {FFAirImpDirectMAWBDetail ? <>({FFAirImpDirectMAWBDetail.mawb_number})</> : ""}</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6 mt-2">
                                            <div className='ms-2'>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                    Job Order No.
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                    <Select
                                                        className='custom-selector'
                                                        options={jobOrderOptions}
                                                        styles={customStyles}
                                                        name="job_order_id"
                                                        onChange={option => {
                                                            formik.setFieldValue('quotation_id', "")
                                                            formik.setFieldValue('job_order_id', option.value);
                                                            formik.setFieldValue("quotation_id", option.quotation_id);
                                                        }}
                                                        value={jobOrderOptions.find(option => option.value === formik.values.job_order_id || null)}
                                                        isLoading={loadingFFAirImpJobOrderList}
                                                        isDisabled={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6 mt-2">
                                            <div className='ms-2'>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                    Quotation No.
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                    <Select
                                                        className='custom-selector'
                                                        options={finalQuotationOptions}
                                                        styles={customStyles}
                                                        name="quotation_id"
                                                        onChange={option => {
                                                            formik.setFieldValue('quotation_id', option.value);
                                                        }}
                                                        value={finalQuotationOptions.find(option => option.value === formik.values.quotation_id || null)}
                                                        isLoading={loadingFFAirImpFinalQuotationList}
                                                        isDisabled={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {(formik.values.job_order_id
                                            // && formik.values.quotation_id
                                        ) && showFormOf == "direct_shipment" ?
                                            <DirectShipmentMAWBEditAI
                                                trans_mode={formik.values.trans_mode}
                                                job_order_id={formik.values.job_order_id}
                                                quotation_id={formik.values.quotation_id}

                                                loadingCurrency={loadingFFAirImpCurrencyList}
                                                currencyOptions={currencyOptions}

                                                loadingAirport={loadingFFAirImpAirportList}
                                                airportOptions={airportOptions}

                                                loadingOrganisation={loadingFFAirImpOrganisationList}
                                                organisationOptions={organisationOptions}

                                                FFAirImpDirectMAWBDetail={FFAirImpDirectMAWBDetail}
                                                b64id={b64id}

                                                iataAgentOptions={iataAgentOptions}


                                                accessedPermission={accessedPermission}

                                                token={token}
                                                user_id={user_id}


                                            />
                                            :
                                            null}
                                        {(formik.values.job_order_id
                                            // && formik.values.quotation_id
                                        ) && showFormOf == "console_shipment" ?
                                            <ConsoleShipmentHAWBEdit
                                                trans_mode={formik.values.trans_mode}
                                                job_order_id={formik.values.job_order_id}
                                                quotation_id={formik.values.quotation_id}

                                                loadingCurrency={loadingFFAirImpCurrencyList}
                                                currencyOptions={currencyOptions}

                                                loadingAirport={loadingFFAirImpAirportList}
                                                airportOptions={airportOptions}

                                                loadingOrganisation={loadingFFAirImpOrganisationList}
                                                organisationOptions={organisationOptions}

                                                FFAirImpDirectMAWBDetail={FFAirImpDirectMAWBDetail}
                                                b64id={b64id}

                                                iataAgentOptions={iataAgentOptions}


                                                accessedPermission={accessedPermission}

                                                token={token}
                                                user_id={user_id}
                                            />
                                            :
                                            null
                                        }

                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
            }

        </>

    )
}

export default EditFFDirectMAWBAI